import { GetDocumentDebitsResponse } from "services";

export function ordenarDebits(array: GetDocumentDebitsResponse["debits"]) {
  const childrenMap = new Map();
  const result = [];

  for (const item of array) {
    const parentId = item.id_linked_debit;

    if (!parentId) {
      result.push(item);
    } else {
      if (!childrenMap.has(parentId)) {
        childrenMap.set(parentId, []);
      }
      childrenMap.get(parentId).push(item);
    }
  }

  let i = 0;
  while (i < result.length) {
    const parent = result[i];
    const children = childrenMap.get(parent.id_debit);
    if (children) {
      result.splice(i + 1, 0, ...children);
      childrenMap.delete(parent.id_debit);
      i += children.length;
    }
    i++;
  }

  for (const orphanChildren of Array.from(childrenMap.values())) {
    result.push(...orphanChildren);
  }

  return result;
}